
import Image from 'next/image';
import Link from 'next/link';
import style from './logo.module.scss';

const Logo = ({ title = 'Casino star', isClickable = true, variant = 'light', logoWidth }) => {

    const image = (
        <Image
            src={`/images/logo/logo-${variant === 'light' ? 'dark' : 'light'}.svg`}
            width={200}
            height={200}
            alt={title}
            className={style.logo}
            style={logoWidth ? { maxWidth: `${logoWidth}rem` } : undefined}
        />
    );

    return isClickable ? (
        <Link href={`/`} title={title} className={style.logo_link}>
            {image}
        </Link>
    ) : (
        image
    );
};

export default Logo;
